import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { JwtStorageService } from '../../shared';
import { ErrorResponse } from '..';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../../store/indicator';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private store: Store<any>,
    private jwtStorageService: JwtStorageService // private messageService: MessageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const accessToken = this.jwtStorageService.getToken();
    // if (accessToken) {
    //   req = req.clone({
    //     setHeaders: { Authorization: `Bearer ${accessToken}` },
    //   });
    // }

    // req = req.clone({
    //   setHeaders: {
    //     'x-client-name': environment.clientName,
    //     'x-client-version': environment.clientVersion,
    //     'Content-Type': 'application/json',
    //     Accept: 'application/json',
    //   },
    // });

    // if (req.url.indexOf('http') !== 0) {
    //   req = req.clone({ url: environment.apiBaseUrl + req.url });
    // }

    // this.store.dispatch(new IndicatorStore.ShowIndicator(req.url));

    return next.handle(req).pipe(
      // map((event: HttpEvent<any>) => {
      //   if (event instanceof HttpResponse) {
      //     console.log('event--->>>', event);
      //   }
      //   return event;
      // }),
      // finalize(() => {
      //   this.store.dispatch(new IndicatorStore.HideIndicator(req.url));
      // }),
      catchError((err: any) => {
        // console.log(
        //   '--- ERR response : ',
        //   err,
        // );
        // rest api server error
        if (err instanceof HttpErrorResponse) {
          const httpErrorResponse = err as HttpErrorResponse;

          switch (httpErrorResponse.status) {
            case 401:
              this.jwtStorageService.removeToken();
              this.router.navigateByUrl('/signin', {
                state: { redirect: window.location.href },
              });
              this.store.dispatch(new IndicatorStore.HideAllIndicator());
              return [];
            case 404:
              // const msg = httpErrorResponse.statusText;
              // this.messageService.add({
              //   severity: 'error',
              //   life: 3000,
              //   summary: `Error: ${httpErrorResponse.status}`,
              //   detail: msg,
              // });
              this.router.navigateByUrl('/not-found');
              this.store.dispatch(new IndicatorStore.HideAllIndicator());
              return [];
            case 400:
            case 403:
            case 406:
              console.error('---!!! ERROR : ', new ErrorResponse(httpErrorResponse.error));
              return throwError(new ErrorResponse(httpErrorResponse.error));
            case 503:
              this.router.navigateByUrl('/service-unavailable');
              this.store.dispatch(new IndicatorStore.HideAllIndicator());
              return [];
            default:
              // TODO: case 500? toast?
              return throwError(httpErrorResponse.error);
          }

          // if (err.error) {
          //   const msg = err.error;
          //   console.log(msg);
          //   this.messageService.add({
          //     severity: 'error',
          //     life: 3000,
          //     summary: `Error: ${msg.statusCode}`,
          //     detail: msg.error,
          //   });
          //   return [];
          // }
        }

        // TOTO: 모든 에러는 처리 해야 됨. toast로 보여 줄지 고민....

        // unhandled error
      })
    );
  }
}
